import { SearchSource } from '@carvana/merch-contracts';
import { useContext } from 'react';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import { useConfiguration } from '~/context/common/StaticContext';
import { useFinanceInfo } from '~/context/srp/FinanceContext';
import SearchEventsDataContext from '~/context/srp/SearchEventsDataContext';
import ConditionalTile from './ConditionalTile';

type OwnProps = {
  tileToShow?: 'low' | 'zero';
  position: number;
};

const tileMap = {
  zero: {
    tileName: 'ZeroDownTile',
    title: 'Zero cash down'
  },
  low: {
    tileName: 'LowDownTile',
    title: 'Low cash down'
  }
};

export default function DownPaymentTile({ tileToShow, position }: OwnProps) {
  const { shouldUseTitleCasing } = useConfiguration();
  const { setSearchSource } = useContext(SearchEventsDataContext);
  const { updateRangeFilter } = useContext(AppliedFiltersContext);
  const trackEvent = useTrackEvent();
  const financeInfo = useFinanceInfo();

  const tile =
    tileToShow ?? (financeInfo?.minDownPayment === 0 ? 'zero' : 'low');
  const { tileName, title } = tileMap[tile];

  return (
    <ConditionalTile
      anchorProps={{
        id: tileName,
        onClick: ev => {
          ev.preventDefault();
          ev.stopPropagation();

          updateRangeFilter({
            filterKey: 'finance',
            value: {
              downPayment: financeInfo?.minDownPayment,
              monthlyPayment: financeInfo?.maxMonthlyPayment
            }
          });

          setSearchSource(SearchSource.Tile);
          trackEvent('Conditional Tile', {
            action: 'clicked',
            tile: tileName,
            position
          });
        }
      }}
      ctaCopy={shouldUseTitleCasing ? 'Shop Now' : 'Shop now'}
      description="Down payments that fit your budget."
      imageProps={{
        src: `${process.env.CVNA_APP_CDN_ASSETS_PATH}/images/heliosConditionalTiles/zerocashdown-illustration.png`,
        alt: 'Zero Cash Down'
      }}
      position={position}
      tileName={tileName}
      title={title}
    />
  );
}
